import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

export default function AlertDismissable({ children, handleDismiss, shown }) {
  if (shown) {
    return (
      <Alert bsStyle="danger" onDismiss={handleDismiss}>
        {children}
      </Alert>
    );
  }
  return null;
}

AlertDismissable.propTypes = {
  children: PropTypes.node.isRequired,
  handleDismiss: PropTypes.func.isRequired,
  shown: PropTypes.bool.isRequired
};
